<div class="page-layout carded left-sidenav toolbar-fixed-layout">
<!--  <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">-->
<!--    <div class="flex flex-col grid-toolbar-buttons-group-container w-p-100 justify-center items-start">-->
<!--      <particle-breadcrumbs [breadcrumbs]="breadcrumbs"></particle-breadcrumbs>-->
<!--    </div>-->
<!--  </div>-->
  <div class="page-layout blank flex flex-col full-grow-no-shrink-no-basis">

    <div class="full-grow-no-shrink-no-basis" style="min-height: 100%;position: relative">
      <div class="add-margin responsive-scroll" style="overflow-x: auto">


        <particle-fx-rate-currency-selector class="flex-1-0-350px"
                                            [title]="reportingCurrencySelectorTitle"
                                            [reportId]="reportId"
                                            [currencyType]="currencyType.Reporting"
                                            (multipleCurrencySelected)="updateRateFormatVisibility($event)">
        </particle-fx-rate-currency-selector>


        <div class="page-separator"></div>

        <particle-fx-rate-currency-selector class="flex-1-0-350px" [title]="translationCurrencySelectorTitle"
                                            [reportId]="reportId"
                                            [currencyType]="currencyType.Translation"></particle-fx-rate-currency-selector>

        <div class="page-separator"></div>

        <particle-report-settings-form #reportSettings *ngIf="showSettings" class="flex-1-0-350px"
                                       [reportModel]="reportModel"
                                       [disableRateFormatSelection]="disableRateFormatSelection"
                                       (formValueChanged)="onFormValueChanges($event)"
                                       (validationChange)="onValidationChange($event)">
        </particle-report-settings-form>


      </div>
    </div>

    <div class="flex flex-row form-footer flex flex-row justify-between items-center">
      <button mat-button class="mat-flat-button orbitax-footer-button mat-button" (click)="cancel()"
              [disabled]="cancelDisabled" data-cy="fx-rate-btn-cancel">Cancel
      </button>
      <button mat-flat-button class="orbitax-footer-action-button mat-button mat-flat-button mat-accent" type="button"
              color="accent" (click)=done() data-cy="fx-rate-btn-done">
        Done
      </button>
    </div>

  </div>
</div>
